import React, { useState, useEffect } from 'react';
import { FaLinkedin, FaTwitter, FaGithub, FaEnvelope, FaPhone, FaArrowUp } from 'react-icons/fa';
import './Contact.css';

function Contact() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const contactSection = document.getElementById("contact");
      if (contactSection) {
        const rect = contactSection.getBoundingClientRect();
        setShowScrollButton(rect.bottom <= window.innerHeight);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section id="contact" className="contact-section d-flex flex-column align-items-center justify-content-center">
      <h1 className="contact-title mb-5">CONTACT</h1>

      <div className="contact-container shadow-lg p-5 rounded">
        <div className="contact-info-bottom">
          <div className="contact-info-item">
            <FaEnvelope className="contact-icon me-2" />
            <a href="mailto:bassitfachir@gmail.com" className="contact-info fs-4">bassitfachir@gmail.com</a>
          </div>
          <div className="contact-info-item">
            <FaPhone className="contact-icon me-2" />
            <span className="contact-info fs-4">+33780278434</span>
          </div>
          <div className="social-icons d-flex justify-content-center mt-4">
            <a href="https://www.linkedin.com/in/m-abdelbassit-mahamadene-fachir-50536b240/" target="_blank" rel="noopener noreferrer" className="social-icon me-4">
              <FaLinkedin />
            </a>
            <a href="https://github.com/erguenibour" target="_blank" rel="noopener noreferrer" className="social-icon me-4">
              <FaGithub />
            </a>
            <a href="https://x.com/AbdelbassitMa19" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaTwitter />
            </a>
          </div>
        </div>
      </div>

      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Abddelbassit Mahamadene Fachir. Tous droits réservés.</p>
      </footer>

      {showScrollButton && (
        <button className="scroll-to-top" onClick={scrollToTop}>
          <FaArrowUp />
        </button>
      )}
    </section>
  );
}

export default Contact;
